import PropTypes from 'prop-types';
import React from 'react';

const SingleField = ({ label, value }) => (
  <dl className="contact-card__detail mb-4" aria-hidden="true">
    <dt className="font-regular-font text-text-blue">{label}</dt>
    <dd className="font-regular-font text-text-blue">{value}</dd>
  </dl>
);

SingleField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default SingleField;
